import React, {Component} from 'react';
import Header from './../components/Header'
import Footer from './../components/Footer'
import {Link} from "react-router-dom";

class NotFoundShop extends Component {

  render() {
    return (
      <div className="body">
        <Header selectShop={false} url_hash={'not-found-shop'} isShowAddress={true}/>
        <main>
          <h1 className="not-found">Not found page</h1>
          <div className="not-found__return-wrap">
            <Link to="/" className="not-found__return">Return to main page</Link>
          </div>
        </main>
        <Footer/>
      </div>
    )
  }
}

export default NotFoundShop;



// WEBPACK FOOTER //
// ./src/routers/NotFound.js